import React, { useState, useRef, useEffect } from "react";
import {BsClock, BsEnvelope, BsFillPencilFill,BsRadar, BsKey, BsAsterisk, BsBuilding, BsTrash, BsShieldPlus , BsShieldMinus, BsPerson  } from 'react-icons/bs';
import { useConfirm } from '../components/ConfirmContext';
import { differenceInDays, parseISO } from "date-fns"; // date-fns ułatwia operacje na datach

export default function RowActions({onDelete, changesubscriberLicensefvOrNot, logedUser, row, onSendLicense, onEdit,onSendOneMoreTime, onRefresh, renvewSubscription, disableSubscription, onSendEmail, editParserAccess, editAditionalModules, onAcceptPrzetwarzanie, onChangeConcurentPlatforms }) {
  const { requestConfirm } = useConfirm();

  const [open, setOpen] = useState(false);
  const [menuPos, setMenuPos] = useState({ x: 0, y: 0 });
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
function SubscriptionButton({ row, disableSubscription, setOpen }) {
  const expireDate = parseISO(row.shop_expireDate); // zakładam, że shop_expireDate jest w formacie ISO
  const daysLeft = differenceInDays(expireDate, new Date());

  const canDisable = daysLeft >= 7;

  return (
    <button
      onClick={
        canDisable
          ? () => {
              requestConfirm(
                `Czy na pewno chcesz wyłączyć subskrypcję użytkownikowi?`,
                () => {
                  disableSubscription(row);
                  setOpen(false);
                }
              );
            }
          : undefined
      }
      className={`flex items-center gap-2 w-full px-3 py-2 ${
        canDisable
          ? "text-primary-500 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
          : "text-gray-400 cursor-not-allowed"
      }`}
    >
      <BsShieldMinus className="w-4 h-4" />
      <span>{canDisable ? "Wyłącz subskrypcję" : "Nie można wyłączyć subskrypcji"}</span>
    </button>
  );
}

  // 🔒 Zamknij po kliknięciu poza (ale nie w menu)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        !buttonRef.current?.contains(e.target) &&
        !menuRef.current?.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // 📍 Pozycjonowanie menu
  const handleToggleMenu = () => {
    if (!open && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPos({ x: rect.right - 180, y: rect.top }); // 180 = szerokość menu
    }
    setOpen((prev) => !prev);
  };
const menuHeight = 200; // albo zmierz refem
const shouldOpenUp =
  menuPos.y + menuHeight > window.innerHeight;
  return (
    <>
      {/* Przycisk trzech kropek */}
      <button
        ref={buttonRef}
        onClick={handleToggleMenu}
        className="p-2 rounded hover:bg-gray-100 transition"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-5 h-5 text-gray-600"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 12h.01M12 12h.01M18 12h.01" />
        </svg>
      </button>

      {/* FIXED menu – nie rozszerza tabeli */}
      {open && (
        <div
        ref={menuRef}
          style={{
    position: "fixed",
    left: `${menuPos.x}px`,
    top: shouldOpenUp ? "auto" : `${menuPos.y}px`,
    bottom: shouldOpenUp
      ? `${window.innerHeight - menuPos.y}px`
      : "auto",
    zIndex: 9999,
  }}
          className="
            bg-white border border-gray-200 rounded-sm shadow-sm
            animate-fadeIn
          "
        >
       <ul className="py-1 text-gray-700">
  {row.needFvTagedToExport === "1" ? (
    <li>
      <button
        onClick={() => {
          requestConfirm(
            `Czy jesteś pewien że chcesz rozliczyć tego użytkownika?`,
            () => {
              onAcceptPrzetwarzanie(row);
              // onSendLicense(row);
              setOpen(false);
            }
          );
        }}
        className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
      >
        <BsKey className="w-4 h-4" />
        <span>Rozlicz fakturę</span>
      </button>
    </li>
  ) : (
    <>
      {row.newAcount === "0" && (
        
        <li>

          {row.user_want_use==="0" ? (
              <button
            onClick={() => {
              requestConfirm(
                `Czy na pewno chsesz włączyć subskrypcję użytkownikowi`,
                () => {
                  renvewSubscription(row);
                  setOpen(false);
                }
              );
            }}
            className="flex items-center text-green-800 gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-green-500 to-green-600 hover:text-white"
          >
            <BsShieldPlus className="w-4 h-4" />
            <span>Włącz subskrypcje</span>
          </button>
          ):( 
        <SubscriptionButton row={row} disableSubscription={disableSubscription} setOpen={setOpen} />
        )}
        
        </li>
      )}
      {row.newAcount === "1" ? (
        <li>
          <button
            onClick={() => {
              requestConfirm(
                `Czy na pewno chcesz wysłać licencję do tego użytkownika?`,
                () => {
                  onSendLicense(row);
                  setOpen(false);
                }
              );
            }}
            className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
          >
            <BsKey className="w-4 h-4" />
            <span>Wyślij licencję</span>
          </button>
        </li>
      ) : (
        <li>
          <button
            onClick={() => {
              requestConfirm(
                `Aplikacja wysyła ponownie informacjie odnosnie licencji do użytkownika. W treści zawarty jest klucz licencji oraz dane do logowania. Póki co opcja zabezpieczona przed przypadkowym kliknięciem. Można na spokojnie zamknąć okno.`,
                () => {
                 onSendOneMoreTime(row);
               setOpen(false);
                }
              );
            }}
           
            className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
          >
            <BsEnvelope className="w-4 h-4" />
            <span>Wyślij ponownie</span>
          </button>
        </li>
      )}

      {row.newAcount === "0" && (
        
        <li>
          <button
            onClick={() => {
              requestConfirm(
                `Czy na pewno chcesz przedłużyć ważność konta?`,
                () => {
                  onRefresh(row);
                  setOpen(false);
                }
              );
            }}
            className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
          >
            <BsClock className="w-4 h-4" />
            <span>Przedłuż ważność konta</span>
          </button>
        </li>
      )}

      <li>
        <button
          onClick={() => {
            onEdit(row);
            setOpen(false);
          }}
          className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
        >
          <BsFillPencilFill className="w-4 h-4" />
          <span>Edytuj</span>
        </button>
      </li>

      <li>
        <button
          onClick={() => {
            editParserAccess(row);
            setOpen(false);
          }}
          className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
        >
          <BsBuilding className="w-4 h-4" />
          <span>Edytuj integracje</span>
        </button>
      </li>

       {(logedUser?.role === "Administrator" || logedUser?.role === "Developer") ? 
             (
              <div>
                <li>
        <button
          onClick={() => {
            editAditionalModules(row);
            setOpen(false);
          }}
          className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
        >
          <BsAsterisk className="w-4 h-4" />
          <span>Edytuj moduły</span>
        </button>
      </li>
             <li>
        <button
          onClick={() => {
            onChangeConcurentPlatforms(row);
            setOpen(false);
          }}
          className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
        >
          <BsRadar className="w-4 h-4" />
          <span>Żródła konkurencji</span>
        </button>
      </li>
      <li>
          <button
            onClick={() => {
              requestConfirm(
                `Czy na pewno chcesz przestawić tryb licencji. Po zatwierdzeniu tryb zostanie przetstawiony i licencja bedzie rozlicznaa badź nie w zaleźności od ustawienia.`,
                () => {
                 changesubscriberLicensefvOrNot(row);
               setOpen(false);
                }
              );
            }}
           
            className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
          >
            <BsPerson className="w-4 h-4" />
            <span>Czy rozliczane?</span>
          </button>
        </li>
         {(logedUser?.role === "Developer") ? (  
          <div>
          {onDelete && (
                    <li>
                      <button
                      onClick={() => {
                        setOpen(false);
                        requestConfirm(
                          `Czy na pewno chcesz usunąć tego użytkownika?`,
                          () => {
                            onDelete(row.id);
                            setOpen(false);
                          }
                        );
                      }}
                        className="flex items-center gap-2 w-full px-3 py-2 hover:bg-gradient-to-br from-primary-500 to-primary-600 hover:text-white"
                      >
                       
                            <BsTrash className="w-4 h-4" />
                        
                        <span>Usuń</span>
                      </button>
                    </li>
                    )}
                    </div>
                    ):('')}
        
      </div>
             ):(
               ''
             )}
     
     
    </>
  )}
</ul>

        </div>
      )}
    </>
  );
}
